import type { TranslationInterface } from './translation.types';

export const enLocale: TranslationInterface = {
  'write-a-message': 'Write a message...',
  'session-closed-lead': 'Your issue has been resolved!',
  'new-conversation': 'New conversation',
  'welcome-title': 'Welcome to our support chat',
  'welcome-description':
    "We're here to help! Start a conversation and we'll get back to you as soon as possible.",
  'your-name': 'Your name',
  'your-email': 'Your email address',
  'start-chat': 'Talk to support',
  'starting-chat': 'Connecting...',
  'i-need-more-help': 'I need more help',
  'this-was-helpful': 'This was helpful',
  optional: 'Optional',
  'no-conversations-yet': 'No conversations yet',
  'back-to-conversations': 'Back to conversations',
  'closed-conversations': 'Closed conversations',
};
